import React from 'react'
import { Icon, Form, Grid } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Title } from '../components'
import { loadAllCompanies, clearCompanies, getCompaniesCSV } from '../../common/companies/actions'
import { checkFile, clearDownload } from '../../common/downloads/actions'
import { lists } from '../../common/lib/redux-lists'
import {
  TextFilter,
  
} from '../components/filters'

import { CompaniesTable } from '../tables'

const { Row, Column } = Grid

class CompaniesPage extends React.Component {
  constructor(props) {
    super(props)
    this.getCSV = this.getCSV.bind(this)
    this.checkCSV = this.checkCSV.bind(this)
  }
  componentWillReceiveProps(props) {
    const oldLocation = this.props.downloadLocation
    const oldPath = this.props.downloadPath
    const newLocation = props.downloadLocation
    const newPath = props.downloadPath

    if (oldLocation !== newLocation && newLocation !== '') {
      props.checkFile(newLocation)
      this.checkCSVInterval = window.setInterval(this.checkCSV, 500)
    } else if (oldPath !== newPath && newPath !== '') {
      window.clearInterval(this.checkCSVInterval)
    }
  }
  componentWillUnmount() {
    const { waitingForDownload, clearDownload, clearCompanies, list } = this.props
    clearCompanies()
    if (waitingForDownload) clearDownload()
    if (this.checkCSVInterval) window.clearInterval(this.checkCSVInterval)
  }
  getCSV() {
    const { list, getCompaniesCSV } = this.props
    const query = list.$query()
    getCompaniesCSV(query)
  }
  checkCSV() {
    const { checkFile, downloadLocation } = this.props
    checkFile(downloadLocation)
  }
  render() {
    const {
      companies, meta, list, viewer, waitingForDownload, downloadPath, clearDownload
    } = this.props

    return (
      <div>
        <Title message="Dopravci" />
        <aside className="breadcrumbs">
          <span>Dopravci</span>

          <div className="options">
            <Link to="/companies/new"><button><Icon name="add" /> Nový dopravce</button></Link>
          </div>
        </aside>
        <main className="content">
          <Form className="filters" size="big">
            <Grid>
              <Row>
                <Column>
                  <strong>Název:</strong>
                  <TextFilter {...list.filters['nameSort.likeCollateStart']} />
                </Column>
              </Row>
            </Grid>
          </Form>
          <CompaniesTable
            companies={companies}
            meta={meta}
            list={list}
            getCSV={['ADMIN','SUPERVISOR'].indexOf(viewer.role) !== -1 && this.getCSV}
            waitingForDownload={waitingForDownload}
            csv={downloadPath}
            clearDownload={clearDownload}
          />
        </main>
      </div>
    )
  }
}

CompaniesPage.defaultProps = {
  waitingForDownload: false,
  downloadPath: '',
  downloadLocation: '',
}

CompaniesPage.propTypes = {
  companies: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  loadAllCompanies: React.PropTypes.func.isRequired,
  clearCompanies: React.PropTypes.func.isRequired,
  list: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  waitingForDownload: React.PropTypes.bool,
  downloadPath: React.PropTypes.string,
  downloadLocation: React.PropTypes.string,
  getCompaniesCSV: React.PropTypes.func.isRequired,
  checkFile: React.PropTypes.func.isRequired,
  clearDownload: React.PropTypes.func.isRequired,
}

CompaniesPage = lists(CompaniesPage, {
  path: 'CompaniesPage',
  filters: ['nameSort.likeCollateStart'],
  headings: ['nameSort'],
  debounceTime: 50,
  loadDataAction: (props) => (props.loadAllCompanies),
  getInitialState: () => ({ sort: 'nameSort' }),
})

export default connect((state) => ({
  companies: state.companies.all,
  meta: state.companies.meta,
  viewer: state.users.viewer,
  waitingForDownload: state.downloads.downloading,
  downloadPath: state.downloads.path,
  downloadLocation: state.downloads.location,
}), { loadAllCompanies, clearCompanies, getCompaniesCSV, checkFile, clearDownload })(CompaniesPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Companies.js